import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';

import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';

export const deleteWebGame: AsyncThunk<
  void,
  number,
  Record<string, unknown>
> = createAsyncThunk<void, number>('web-games/get-web-game', async gameId => {
  const url: string = createPathParams<'id'>(Endpoints.WEB_GAME_BY_ID, {
    id: gameId,
  });
  await axiosInstance.delete(url);
});
